import { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { Button, Card, CardContent } from '@/components/ui'
import { SOCIAL_MEDIA } from '@/lib/constants'

export default function LinkInBioPage() {
  useEffect(() => {
    document.title = 'Link in Bio | Fugue Lab'
  }, [])

  return (
    <div className="bg-background text-foreground flex min-h-screen flex-col items-center space-y-6 px-4 py-8">
      {/* Logo or Avatar */}
      <img src="/logo.png" alt="Fugue Lab Logo" width={80} height={80} className="rounded-full" />

      {/* Intro Text */}
      <div className="space-y-1 text-center">
        <h1 className="text-xl font-semibold">Fugue Lab</h1>
        <p className="text-muted-foreground text-sm">LA-based digital agency for classical music</p>
      </div>

      {/* Links */}
      <div className="w-full max-w-sm space-y-3">
        <Card>
          <CardContent className="p-0">
            <a href="https://calendly.com/garrett-garrettjohnlaw/30min" target="_blank" rel="noopener noreferrer">
              <Button variant="link" className="w-full py-4 text-base">
                Book a Free Call
              </Button>
            </a>
          </CardContent>
        </Card>

        <Card>
          <CardContent className="p-0">
            <Link to="/portfolio">
              <Button variant="link" className="w-full py-4 text-base">
                See Our Work
              </Button>
            </Link>
          </CardContent>
        </Card>

        <Card>
          <CardContent className="p-0">
            <Link to="/packages">
              <Button variant="link" className="w-full py-4 text-base">
                View Packages & Pricing
              </Button>
            </Link>
          </CardContent>
        </Card>

        <Card>
          <CardContent className="p-0">
            <a href="https://classicallyminded.com" target="_blank" rel="noopener noreferrer">
              <Button variant="link" className="w-full py-4 text-base">
                Classically Minded Blog
              </Button>
            </a>
          </CardContent>
        </Card>

        <Card>
          <CardContent className="p-0">
            <Link to="/about">
              <Button variant="link" className="w-full py-4 text-base">
                About Fugue Lab
              </Button>
            </Link>
          </CardContent>
        </Card>
      </div>

      {/* Social Links */}
      <div className="flex items-center gap-4 pt-4">
        <a
          href="https://instagram.com/fugue.lab"
          target="_blank"
          rel="noopener noreferrer"
          className="text-muted-foreground hover:text-foreground text-sm transition-colors"
        >
          @fugue.lab
        </a>
        <span className="text-muted-foreground">·</span>
        <a
          href={SOCIAL_MEDIA.linkedin}
          target="_blank"
          rel="noopener noreferrer"
          className="text-muted-foreground hover:text-foreground text-sm transition-colors"
        >
          LinkedIn
        </a>
      </div>
    </div>
  )
}
